import { useTranslate } from "ra-core";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import DealList from "./DealList";
import { ProjectSwitcher } from "../projects/ProjectSwitcher";

/**
 * «Сделки» on a phone: the same board as on a desktop. The columns keep their
 * width and the board scrolls sideways inside itself, the page does not.
 */
export const DealListMobile = () => {
  const translate = useTranslate();
  return (
    <>
      <MobileHeader showRefresh>
        <div className="flex items-center gap-3 min-w-0">
          <h1 className="text-xl font-semibold">
            {translate("resources.deals.name", { smart_count: 2 })}
          </h1>
          <ProjectSwitcher className="max-w-40" />
        </div>
      </MobileHeader>
      <MobileContent>
        <DealList />
      </MobileContent>
    </>
  );
};
